import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconPrice: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="price">
    <path d="M12.6 5.9v1.502A2.6 2.6 0 0 1 15.1 10h-1.2a1.4 1.4 0 0 0-1.4-1.4h-1.077a1.323 1.323 0 0 0-.26 2.62l1.909.382A2.523 2.523 0 0 1 12.6 16.6v1.5h-1.2v-1.502A2.6 2.6 0 0 1 8.9 14h1.2a1.4 1.4 0 0 0 1.4 1.4h1.077a1.323 1.323 0 0 0 .26-2.62l-1.909-.382A2.523 2.523 0 0 1 11.4 7.4V5.9h1.2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-1.2 0a7.8 7.8 0 1 1-15.6 0 7.8 7.8 0 0 1 15.6 0Z"
    />
  </Icon>
);
